import React from 'react';
import { Bleed } from '@atlaskit/primitives/compiled/bleed';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import { cssMap } from '@atlaskit/css';
import { defineMessage, useIntl } from '@atlassian/jira-intl';

const verifiedTeamsOnlyMessage = defineMessage({
	id: 'issue-field-team.verified-team-footer.verified-teams-only-message',
	defaultMessage: 'Only verified teams are shown',
	description:
		'Message shown in the team picker footer when the field is configured to show only verified teams',
});

const styles = cssMap({
	footerBorder: {
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
	outerContainer: {
		display: 'flex',
		alignItems: 'center',
		alignSelf: 'stretch',
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.075'),
		paddingRight: token('space.075'),
	},
	innerContainer: {
		display: 'flex',
		width: '100%',
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.075'),
		paddingRight: token('space.075'),
		alignItems: 'center',
		backgroundColor: token('color.background.input.hovered'),
		borderRadius: token('radius.small'),
		alignSelf: 'stretch',
	},
	contentWrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.075'),
	},
});

export function VerifiedTeamFooter(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Bleed inline="space.200" block="space.100">
			<Box xcss={styles.footerBorder} />
			<Box xcss={styles.outerContainer} testId="field-team.verified-team-footer">
				<Box xcss={styles.innerContainer}>
					<Box xcss={styles.contentWrapper}>
						<InformationCircleIcon label="" size="small" color={token('color.icon.subtle')} />
						<Text color="color.text.subtlest">{formatMessage(verifiedTeamsOnlyMessage)}</Text>
					</Box>
				</Box>
			</Box>
		</Bleed>
	);
}
